import type { CancelablePromise } from "./core/CancelablePromise"
import { OpenAPI } from "./core/OpenAPI"
import { request as __request } from "./core/request"

export type DomainCheckResult = {
    valid: boolean
    product?: string
    company_name?: string
    logo?: string
    request_domain?: string
    instance_domain?: string
    error?: string
}

export type SaasRegisterRequest = {
    company_name: string
    subdomain: string
    admin_email: string
    password: string
}

export type SaasRegisterResponse = {
    message: string
}

export type SaasVerifyResponse = {
    message: string
    subdomain: string
    login_url: string
}

export class PublicService {
    /**
     * Check if a domain/subdomain is valid and get its metadata.
     * GET /v1/public/domain-check
     */
    public static domainCheck(data: { domain?: string }): CancelablePromise<DomainCheckResult> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/v1/public/domain-check",
            query: {
                domain: data.domain,
            },
        })
    }

    /**
     * Register a new company (SaaS).
     * POST /v1/public/saas/register
     */
    public static saasRegister(data: SaasRegisterRequest): CancelablePromise<SaasRegisterResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/v1/public/saas/register",
            body: data,
        })
    }

    /**
     * Verify company registration and activate account.
     * GET /v1/public/saas/verify
     */
    public static saasVerify(data: { token: string }): CancelablePromise<SaasVerifyResponse> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/v1/public/saas/verify",
            query: {
                token: data.token,
            },
        })
    }
}
